export default "__VITE_ASSET__BheJrBpL__"